import { Component, Input, OnInit } from '@angular/core';
import { CloudbedsService } from '@app/services/cloudbeds.service';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-popup-update',
  templateUrl: './popup-update.component.html',
  styleUrls: ['./popup-update.component.scss'],
})
export class PopupUpdateComponent implements OnInit {

  @Input() title: any;
  @Input() image: any;
  @Input() text: any;
  @Input() text2: any;
  @Input() text3: any;
  @Input() buttons: any;
  @Input() small: any;
  @Input() showList: any;
  @Input() upgrade: any;
  @Input() qrcode: any;
  @Input() reservationNumber: any;
  upgradeList: any;
  upgradeType: number;
  constructor(
      private modalCtrl: ModalController,
      public cloudbedService: CloudbedsService,) { }

  ngOnInit() {
    console.log(this.upgrade)
  }

  callback(value: any){
    console.log(value)
    this.modalCtrl.dismiss({value});
  }
}
